<template>
<div>
  <b-navbar toggleable="sm" type="dark" variant="dark">
    <b-dropdown size="sm" variant="link" toggle-class="text-decoration-none" no-caret>
      <template slot="button-content">
        <i class="fas fa-bars" style="color:white"></i>
      </template>
      <b-dropdown-item :to="'/ludotheque'">Ludothèque de l'association</b-dropdown-item>
    </b-dropdown>
    
    <b-navbar-brand :to="'/'">Ludosphère Carquefolienne</b-navbar-brand>
    
    <b-nav-form class="right-nav" v-if="!isConnected()">
      <b-button size="sm" variant="success" @click="showLogin = true">Connexion</b-button>
    </b-nav-form>

    <div class="ml-auto flow-row">
      <div class="help-button clickable" >
         <img width="28" height="28" src="@/assets/help-icon.png" @click="openHelp">
      </div>
      <b-nav-form class="right-nav" v-if="!isConnected()">
        <b-button size="sm" variant="success" @click="showLogin = true">Connexion</b-button>
      </b-nav-form>
      <b-collapse is-nav v-if="isConnected()">
        <b-navbar-nav>
          <b-nav-item-dropdown right>
            <template slot="button-content">
              <Avatar :user="profile" noTip="true" />
            </template>
            <b-dropdown-item href="#" @click="$router.push('/profil')">Profil</b-dropdown-item>
            <b-dropdown-item href="#" @click="$router.push('/administration')" v-if="isAdmin()">Administration</b-dropdown-item>
            <b-dropdown-item href="#" @click="disconnect">Déconnexion</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </div>

  </b-navbar>

  <b-modal v-model="showLogin" id="login-modal" title="Connexion"  hide-footer no-close-on-backdrop>
      <b-form>
        <b-form-group label="Adresse e-mail:" label-for="username">
          <b-form-input
            id="username"
            v-model="login.username"
            type="text"
            @keydown.native.enter="doLogin"
            @keydown.native="hideLoginError"
            required
          ></b-form-input>
        </b-form-group>
    
        <b-form-group label="Mot de passe:" label-for="password">
          <b-form-input
            id="password"
            v-model="login.password"
            required
            type="password"
            @keydown.native="hideLoginError"
            @keydown.native.enter="doLogin"
          ></b-form-input>
        </b-form-group>
        
        <div v-if="incorrectLogin" class="error-text">
          Erreur : Email ou mot de passe incorrect
        </div>
        
        <b-button variant="primary" @click="doLogin">Connexion</b-button>
        <b-button variant="primary-outline" @click="gotoForgotPwd">Mot de passe oublié</b-button>
      </b-form>
  </b-modal>
  
  <b-modal v-model="showForgetPwd" title="Mot de passe oublié"  hide-footer no-close-on-backdrop>
      <b-form>
        <b-form-group label="Adresse e-mail:" label-for="username">
          <b-form-input
            id="username"
            v-model="forgetPwdEmail"
            type="text"
            @keydown.native.enter="doForgotPwd"
            required
          ></b-form-input>
        </b-form-group>
        <div class="g-recaptcha" id="captcha"></div>
    
        <b-button variant="primary" @click="doForgotPwd">Envoyer un nouveau mot de passe</b-button>
      </b-form>
  </b-modal>
  
  <b-modal v-model="showForgotPwdOk" title="Envoyé" ok-only>
    <div>
      Un email de réinitialisation de mot de passe a été envoyé.
    </div>
  </b-modal>
  <b-modal v-model="showForgotPwdFailed" title="Erreur" ok-only>
    <div>
      Une erreur empèche la réinitialisation de votre mot de passe. Veuillez réessayer plus tard.
    </div>
  </b-modal>
</div>
</template>

<script>
import Vue from 'vue'
import Avatar from '@/components/parts/Avatar'

export default {
  name: 'Header',
  components:{
    Avatar,
	},
  data: function(){
    return {
      login: {},
      showLogin: false,
      showForgetPwd: false,
      showForgotPwdOk: false,
      showForgotPwdFailed: false,
      forgetPwdEmail: "",
      incorrectLogin: false,
      profile: {}
    }
  },
  created: function(){
    Vue.$backend.getData().then(res => this.profile = res)
  },
  methods: {
    doLogin() {
      Vue.$backend.login(this.login.username, this.login.password)
        .then(() => {
          this.incorrectLogin = false
          this.showLogin = false
          window.location.reload()
        })
        .catch(() => {
          this.incorrectLogin = true
        });
    },
    hideLoginError(){
      this.incorrectLogin = false
    },
    isConnected(){
      return Vue.$isConnected()
    },
    isAdmin(){
      return Vue.$isAdmin()
    },
    disconnect(){
      Vue.$backend.logout()
      .then(() => {
        this.$router.push('/')
        this.$forceUpdate()
      })
    },
    gotoForgotPwd(){
       this.showLogin = false
       this.showForgetPwd = true
       grecaptcha.render('captcha', {
           'sitekey' : '6Lf6irQUAAAAADg_3FSnTOVnU0dpqftSADNdQppm'
         });
    },
    doForgotPwd(){
    	const captcha = grecaptcha.getResponse()

      Vue.$backend.resetPassword(this.forgetPwdEmail, captcha)
        .then(() => {
          this.forgetPwdEmail = ""
          this.showForgetPwd = false
          this.showForgotPwdOk = true
        })
        .catch(() => {
          this.forgetPwdEmail = ""
          this.showForgetPwd = false
          this.showForgotPwdFailed = true
        });
    },
    openHelp(){
      this.$router.push('/aide')
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.right-nav{
  position: absolute;
  right: 10px;
}

.error-text{
  color: red;
  margin: 10px 0;
}

.dropdown-toggle::after{
  color: red;
}

.g-recaptcha{
  margin-bottom: 10px;
}

.flow-row{
  flex-direction: row;
  display: flex;
}

.help-button{
  margin: auto;
}


.help-button img{
  width: 30px;
  height: 30px;
  margin-bottom: 4px;
}

</style>
